import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
`;

export const CertificateContent = styled.div`
  border: 10px solid #008037;
  padding: 20px;
  margin-top: 20px;
  width: 1024px;
  height: 768px;
  margin-left: auto;
  margin-right: auto;
  font-family: Arial, sans-serif;
  perspective: 1000px;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.8s;

  &.is-flipped {
    transform: rotateY(180deg);
  }

  .certificate-face {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .certificate-back {
    transform: rotateY(180deg);
  }

  .header {
    text-align: center;
    margin-bottom: 40px;
    h1 {
      font-size: 2.5em;
      color: #333;
    }
  }

  .body {
    text-align: center;
    margin-bottom: 40px;
    p {
      font-size: 1.2em;
      color: #555;
    }
    h2 {
      font-size: 2em;
      color: #000;
      margin: 20px 0;
    }
    ul {
      list-style: none;
      padding: 0;
      margin-top: 20px;
      li {
        font-size: 1.2em;
        color: #555;
        margin-bottom: 10px;
      }
    }
  }

  .footer {
    text-align: center;
    margin-top: 50px;
    p {
      font-size: 1em;
      color: #777;
    }
  }
`;
